export { default as BannersCarouselSlot } from './BannersCarouselSlot/BannersCarouselSlot';
export { default as DeliveryInfoBarMobile } from './DeliveryInfoBarMobile/DeliveryInfoBarMobile';
export { default as HomepageIntroDesktop } from './HomepageIntroDesktop/HomepageIntroDesktop';
export { default as HomepageIntroMobile } from './HomepageIntroMobile/HomepageIntroMobile';
export { default as HomepageSlots } from './HomepageSlots/HomepageSlots';
